import Skeleton from 'react-loading-skeleton';

import LaunchpadWidgetWrapper from '../../LaunchpadWidgetWrapper';
import '../Widgets.scss';
import TruncatedDescription from '../../../../BayDashboard/components/TruncatedDescription';

interface SkeletonGroupProps {
	count: number;
}

const SkeletonGroup = ({ count }: SkeletonGroupProps) => (
	<div className="d-flex flex-column gap-3">
		{Array(count)
			.fill(null)
			.map((_, index) => (
				<Skeleton key={index} borderRadius={2} height={24} width={198} />
			))}
	</div>
);

interface Link {
	id: string;
	label: string;
	path: string;
	isVisible: boolean;
}

interface Section {
	sectionTitle: string;
	showSection?: boolean;
	options: Link[];
}

interface OtherLinksWidgetProps {
	widgetDetails?: any;
	editMode?: boolean;
	widgets?: any[];
	setWidgets?: (widgets: any[]) => void;
	setSnackbar?: (snackbar: any) => void;
	t: (key: string) => string;
	defaultWidgetStyles?: any;
	widgetCustomizationData?: any;
	setWidgetCustomizationData?: (data: any) => void;
	widgetFinishStatus?: any;
	setWidgetFinishStatus?: (status: any) => void;
	isInPreviewMode?: boolean;
	editModalInputFields?: any;
	setEditModalInputFields?: (fields: any) => void;
	handleLinkClick?: any;
	isLoading?: boolean;
	selectLaunchpadSettingsData?: any;
}

const OtherLinksWidget = ({
	widgetDetails,
	editMode = false,
	widgets = [],
	setWidgets = () => {},
	setSnackbar = () => {},
	t,
	defaultWidgetStyles,
	widgetCustomizationData,
	setWidgetCustomizationData = () => {},
	widgetFinishStatus,
	setWidgetFinishStatus = () => {},
	isInPreviewMode,
	editModalInputFields,
	setEditModalInputFields = () => {},
	handleLinkClick = () => {},
	isLoading = false,
	selectLaunchpadSettingsData,
}: OtherLinksWidgetProps) => {
	const renderLoadingSkeleton = () => (
		<>
			<SkeletonGroup count={5} />
			<div className="w-100 border-top border-secondary-subtle" />
			<SkeletonGroup count={5} />
		</>
	);

	return (
		<LaunchpadWidgetWrapper
			defaultWidgetStyles={defaultWidgetStyles}
			editModalInputFields={editModalInputFields}
			editMode={editMode}
			handleLinkClick={handleLinkClick}
			helpTooltip="otherLinksWidgetHelpTooltip"
			hideHeader
			isInPreviewMode={isInPreviewMode}
			isOtherLink
			isTitleBlock
			selectLaunchpadSettingsData={selectLaunchpadSettingsData}
			setEditModalInputFields={setEditModalInputFields}
			setSnackbar={setSnackbar}
			setWidgetCustomizationData={setWidgetCustomizationData}
			setWidgetFinishStatus={setWidgetFinishStatus}
			setWidgets={setWidgets}
			t={t}
			widgetCustomizationData={widgetCustomizationData}
			widgetDetails={widgetDetails}
			widgetFinishStatus={widgetFinishStatus}
			widgets={widgets}
		>
			<div className="bay-widget">
				<div className="other-links-widget-body overflow-auto d-flex flex-column gap-5 ps-2">
					{isLoading
						? renderLoadingSkeleton()
						: Object.entries(
							isInPreviewMode && widgetCustomizationData?.sections
								? widgetCustomizationData?.sections
								: defaultWidgetStyles?.sections,
						)
							.filter(([sectionKey, section]) => {
								if (['firstTabLinks', 'thirdTabLinks'].includes(sectionKey)) {
									return (section as Section).showSection;
								}
								return true;
							})
							.map(([sectionKey, section], sectionIndex, sectionArray) => (
								<div key={sectionKey}>
									<div className="d-flex flex-column gap-3">
										<h6 className="fs-6 fw-semibold mb-3">
											{(section as Section).sectionTitle}
										</h6>
										<div className="d-flex flex-column gap-2 fs-6">
											{(section as Section).options
												.filter((option) => option.isVisible)
												.map((option) => {
													return (
														<a
															key={option.id}
															className="text-decoration-none d-inline-block"
															href={option.path}
															style={{
																color: isInPreviewMode
																	? widgetCustomizationData?.linkColor
																	: defaultWidgetStyles?.linkColor,
																width: 'fit-content',
															}}
															target="_blank"
															onClick={(e) => handleLinkClick(e, option.path)} rel="noreferrer"
														>
															{sectionKey === 'firstTabLinks' ? (
																<TruncatedDescription
																	eventName={option.label}
																	style="multiline-ellipsis-desc"
																	type="description"
																/>
															) : (
																option.label
															)}
														</a>
													);
												})}
										</div>
									</div>
									{sectionIndex < sectionArray.length - 1 && (
										<div className="w-100 border-top border-secondary-subtle mt-4" />
									)}
								</div>
							))}
				</div>
			</div>
		</LaunchpadWidgetWrapper>
	);
};

export default OtherLinksWidget;
